import React, { FC } from "react";
import appleStoreIcon from "../../../../assets/icon-apple-store.png";
import googlePlayIcon from "../../../../assets/icon-google-play.png";
import landingDog from "../../../../assets/img/landing-page/landingDog.png";
import landingBubble from "../../../../assets/img/landing-page/landing_bubble.png";
import "./landing-section.css";
import { useMediaQuery } from "@mui/material";
import { LandingStoreButtons } from "../appMocks/LandingStoreButtons";

interface LandingSectionProps {
  handlePlayNowClick: () => void;
}

const LandingSection: FC<LandingSectionProps> = ({ handlePlayNowClick }) => {
  const isMobile = useMediaQuery('(max-width:767px)');

  if (isMobile) return null;

  return (
    <div
      className="flex flex-col relative w-fit h-100 xs-h-auto xs-shrink-0 rightheaderText train_the_fun "
      style={{ justifyContent: "flex-start", gap: "0px" }}
    >
      <div>
        {/* font-family: "Road Rage", sans-serif; */}
        <div className="landing--title flex flex-col xs-mb-2 border-2 border-red-500 ">
          {/* <span style={{ marginTop: "-30px", fontWeight: "bold" }} className="hidden xs-block fs-h-1 lh-h-1 fw-500 sm-fs-h-2  sm-lh-h-2 xs-fs-h-6 xs-lh-h-6 xs-text-center xs-align-center xs-justify-center c-text-1 ">
            <div style={{ fontFamily: "Fredoka", letterSpacing: "2px", fontWeight: "700", color: "black", fontSize: "22px", paddingBottom: "5px",marginTop:"30px" }}><img src={headerTextLogo} style={{maxWidth:"12.37rem"}} /></div>
            <br className="xs-hidden" />                      
            <span className="lh-h-1 sm-lh-h-2  xs-lh-h-6 " style={{ whiteSpace: "nowrap", fontFamily: "Rubik", fontWeight: "500" }}>
              Train the fun way!
            </span>
          </span> */}
          <span
            className="media_tab  xs-hidden lh-h-3 fw-700 sm-fs-h-4 sm-lh-h-2 xs-fs-h-3 xs-lh-h-4 xs-text-center xs-align-center xs-justify-center c-text-1"
            style={{
              fontSize: "clamp(1.4rem, -0.886rem + 5.695vw, 4.6rem)",
              whiteSpace: "nowrap",
              fontFamily: "Rubik",
              fontWeight: "500",
            }}
          >
            Train the fun way!
          </span>
        </div>
        <div className="flex justify-start text-left align-start xs-hidden">
          <p
            className="media_tab_bite fw-500 fs-h-8 lh-h-5 sm-fs-h-9 sm-lh-xl c-blue-sky mt-5 sm-mt-2"
            style={{
              fontSize: "clamp(1rem, 0.5rem + 1.333vw, 1.7rem)",
              fontFamily: "Rubik",
            }}
          >
            Bite-sized games that build real-life skills
          </p>
        </div>
        <div className="landing--play-btn xs-shrink-0 w-100 flex xs-justify-center  xs-mx-auto pr-6">
          <LandingStoreButtons />
        </div>
        <div className="landing--play-btn flex w-100  xs-hidden sm-mt-5 mt-10">
          <div
            className="btn btn--s btn--primary sm-btn xs-btn--lg  fs-h-10"
            onClick={() => handlePlayNowClick()}
            style={{ fontFamily: "Rubik", letterSpacing: "2px" }}
          >
            PLAY NOW
          </div>
        </div>
      </div>
      <div
        className="xs-hidden flex align-end "
        style={{
          marginTop: "150px",
          minWidth: "400px",
          maxWidth: "400px",
          height: "150px",
        }}
      >
        <div
          className="flex align-end relative "
          style={{ height: "" }}
        >
          {" "}
          <img src={landingDog} alt="" className="dog-size" />
        </div>

        <div
          className="flex relative justify-end md-hidden "
          style={{ height: "100%" }}
        >
          <div
            style={{ marginTop: "-80px" }}
            className="bubble-size relative"
          >
            <img
              src={landingBubble}
              alt=""
              style={{ width: "100%" }}
            />
            <div
              style={{
                position: "absolute",
                left: "5%",
                // padding: "10px, 10px, 10px, 10px",
                top: "8%",
                // height: "65%",
                width: "90%",
                textAlign: "center",
                color: "#0C82B6",
                fontWeight: "bold",
                // fontSize: ".8rem",
                whiteSpace: "nowrap",
                fontFamily: "Rubik",
              }}
              className="fw-500 bubble-text "
            >
              I’m Flip, let’s make you <br></br>the best pup parent
              ever!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingSection;